/**
 * Authentication utilities for managing Ember tokens in local storage.
 */

export const getBaseToken = (): string | null => localStorage.getItem('ember_base_token')

export const getContextToken = (): string | null => localStorage.getItem('ember_context_token')

export const clearTokens = (): void => {
  localStorage.removeItem('ember_base_token')
  localStorage.removeItem('ember_context_token')
}

/**
 * Decodes the JWT payload without verification.
 * Used for client-side UI logic and realm checking.
 */
export const getTokenPayload = (token: string | null = getContextToken()): any | null => {
  if (!token) return null

  try {
    const parts = token.split('.')
    const payloadPart = parts[1]
    if (!payloadPart || parts.length !== 3) return null

    // Convert base64url to base64
    const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )

    return JSON.parse(jsonPayload)
  } catch (err) {
    console.error('Failed to decode token payload:', err)
    return null
  }
}

export const isAuthenticated = (): boolean => {
  const token = getContextToken()
  if (!token) return false

  const payload = getTokenPayload(token)
  if (!payload || !payload.exp) return false

  // Check if expired (exp is in seconds)
  const now = Math.floor(Date.now() / 1000)
  return payload.exp > now
}
